import React from 'react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Ready to Elevate Your Brand?</h2>
        <p className="cta-description">
          Partner with CodeGenexis and take the first step towards transforming your digital presence.
        </p>
        <a href="https://api.whatsapp.com/send?phone=9709072209" target="_blank" rel="noopener noreferrer" className="cta-button">Book Free Consultation</a>
      </div>
    </section>
  );
};

export default CTASection; 